// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"db80e185","453":"a6996bf3","554":"b725d68f"}[chunkId] + ".chunk.js";
};